import { Injectable } from "@angular/core";
// import jwtDecode from 'jwt-decode';
import { jwtDecode } from "jwt-decode";
import { Router } from "@angular/router";
import { LocalStorageType } from "../types/localStorage.type";
import { SessionNotificationModel } from "../models/sessionNotification.model";
import { TokenModel } from "../models/token.model";

@Injectable({
    providedIn: 'root',
})
export class SessionService {
    constructor(
        private router: Router
    ) {

    }

    public async callback(): Promise<boolean>{
        const callbackUrl = localStorage.getItem(LocalStorageType.CallbackUrl)

        if(!callbackUrl)
            return false;

        await this.router.navigate([callbackUrl]);

        return true;
    }

    public isTokenExpiredOrNull(): SessionNotificationModel {
        const token = localStorage.getItem(LocalStorageType.JwtToken);
        let decodeToken: TokenModel;

        if(token === null)
            return {
                message: 'Token de acesso não encontrado.',
                hasAccess: false,
                decodedToken: null
            };
        
        try {
            decodeToken = jwtDecode(token!) as TokenModel;

            const currentTimestamp = Math.floor(Date.now() / 1000);

            if(decodeToken.exp > currentTimestamp)
                return {
                    message: null,
                    hasAccess: true,
                    decodedToken: decodeToken
                };
            
            return {
                message: 'Sessão expirada.',
                hasAccess: false,
                decodedToken: null
            };
        } catch (error) {
            return {
                message: 'Não foi possível decodificar o token de acesso.',
                hasAccess: false,
                decodedToken: null
            };
        }
    }

    redirectFromRoute!: string;

    public getRedirectFromRoute(): string {
        return this.redirectFromRoute;
    }

    public setRedirectFromRoute(route: string): void {
        this.redirectFromRoute = route;
    }
}